module.exports = __webpack_public_path__ + "img/p4.be1f2123.jpg";